import { render, staticRenderFns } from "./ns-database-update.vue?vue&type=template&id=471d801a&"
import script from "./ns-database-update.vue?vue&type=script&lang=js&"
export * from "./ns-database-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports